import { ApplicationWso2 } from '../domain/ApplicationWso2'
import { ApplicationWso2FormData } from '../domain/ApplicationWso2FormData'

export const formDataFromApplicationWso2 = (input: ApplicationWso2): ApplicationWso2FormData => ({
	applicationName: input.applicationName,
	corporateGroup: { label: input.corporateGroup.name, value: input.corporateGroup.id },
	active: input.active,
})
